import RDownloadConfirm from "./RDownloadConfirm";

export default RDownloadConfirm